import en_US from './en_US';
import zh_CN from './zh_CN';

export default {
  en_US,
  zh_CN,
};
